var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98505 3.33333H13.3333C14.4379 3.33333 15.3333 4.22876 15.3333 5.33333V10.6667C15.3333 11.7712 14.4379 12.6667 13.3333 12.6667H4C2.89543 12.6667 2 11.7712 2 10.6667V4C2 2.89543 2.89543 2 4 2H7.58911C7.79047 2 7.98105 2.09101 8.10762 2.24763L8.98505 3.33333ZM7.27073 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4V10.6667C3.33333 11.0349 3.63181 11.3333 4 11.3333H13.3333C13.7015 11.3333 14 11.0349 14 10.6667V5.33333C14 4.96514 13.7015 4.66667 13.3333 4.66667H8.66667C8.4653 4.66667 8.27473 4.57565 8.14816 4.41904L7.27073 3.33333Z",
    fill: "#DC2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98505 5.33333H11.3333C12.4379 5.33333 13.3333 6.22876 13.3333 7.33333V12.6667C13.3333 13.7712 12.4379 14.6667 11.3333 14.6667H2C0.89543 14.6667 0 13.7712 0 12.6667V6C0 4.89543 0.89543 4 2 4H5.58911C5.79047 4 5.98105 4.09101 6.10762 4.24763L6.98505 5.33333Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.11018f02.svg";
export { ForwardRef as ReactComponent };